import { ShopRendererThemesApiClient } from '@fourthwall/services/dist/ShopRendererThemesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useActivateThemeMutation = createMutationHook(
  ShopRendererThemesApiClient.activateTheme,
  {
    mutationKey: ['activateTheme'],
  },
)
